import React from 'react';
import { Hairline, BreadcrumbsConnected } from 'elements';
import { RawContent } from 'elements/util';
import {
  SiteContainer,
  Flex,
  Wrapper,
  Main,
} from 'core/layout';
// import tulkojumi from 'utils/tulkojumi';
import { getParsedDataFromPages } from 'utils/deepProps';
import {
  Header,
  StyledHeading,
  StyledContent,
} from './styled';
import { Deputats } from './components';

class Deputati extends React.PureComponent {
  render() {
    const {
      lang,
      path,
      data: {
        page,
        dome,
        type,
        teksti
      },
    } = this.props;



    // const acf = getParsedDataFromPages(page, 'acf');
    // console.log(acf)

    return (

      <SiteContainer>

        <BreadcrumbsConnected
          lang={lang}
          path={path}
        />

        <Wrapper>
          <Flex>
            <Main>
              <StyledHeading>
                {page.title}
              </StyledHeading>
            </Main>
          </Flex>
              <Hairline fat='true'/>
          <Flex>
            <Main>
              <StyledContent>
                <RawContent content={page.content} />
              </StyledContent>
            </Main>
          </Flex>

         <Flex wrap='true'>
              { dome.posts ? dome.posts.map((deputats, index) => (
                <Deputats type={type} deputats={deputats} teksti={teksti} key={index} /> )) : null   }
          </Flex>

        </Wrapper>

      </SiteContainer>

    );
  }
}

export default Deputati;



// WEBPACK FOOTER //
// ./src/pages/Deputati/Deputati.jsx